import CustomModal from "@UI/CustomModal"
import { ReactComponent as SearchIcon } from '@assets/icons/search.svg'
import PropTypes from "prop-types"
import { Button } from "antd"
import { CustomSelect } from "@UI/CustomSelect"
import { CustomInput } from "@UI/CustomInput"
import { CustomCheckbox } from "@UI/CustomCheckbox"
import { useUsersModal } from "./hooks/useUsersModal"
import './styles.css'

const UsersModal = ({
  debtors = [],
  isModalOpen,
  handleModalClose
}) => {
  const {
    currentDebtors,
    loadingUsersModal,
    selectedPlaces,
    setCurrentDebtors,
    handleSelectPlace,
    handleSearchPlace,
    handleCheckAllPlaces,
    handleDownloadTemplateWithSelectedUsers
  } = useUsersModal({ debtors, handleModalClose })

  return (
    <CustomModal
      destroyOnClose={true}
      className="custom-modal check-users-modal"
      isOpenModal={isModalOpen}
      footer={<div className="users-modal-form-footer">
        <Button
          className="btn-standard-green"
          htmlType="buttom"
          shape="round"
          style={{ width: 'fit-content' }}
          loading={loadingUsersModal}
          onClick={handleDownloadTemplateWithSelectedUsers}
        >
          DESCARGAR PLANTILLA
        </Button>
      </div>}
      onCancel={() => {
        handleModalClose({ isOpenModal: false })
      }}
      width={620}
    >
      <div className="users-modal-body">
        <div className="users-modal-title">
          <span>Seleccionar usuarios manualmente</span>
          <p>Elige a los usuarios a los que deseas asignar un cobro, una vez seleccionados los usuarios, haz clic en "Descargar plantilla" para obtener el archivo con los datos elegidos.</p>
        </div>
        <div className="users-modal-options">          
          <CustomInput
            placeholder={'Buscar usuarios (local)'}
            onChange={(e) => handleSearchPlace({ value: e.target.value })}
            onClear={() => setCurrentDebtors(debtors)}
            isComponentIcon
            suffixIcon={<SearchIcon />}
          />
        </div>
        <div className="users-modal-table">
          <div className="users-modal-table-header">
            <span>{selectedPlaces.length} Seleccionados</span>
            <CustomCheckbox
              className={"users-modal-checkbox"}
              onChange={handleCheckAllPlaces}
              value={selectedPlaces.length === debtors.length ? ['all'] : []}
              options={[{ label: 'Todos', value: 'all' }]}
            />
          </div>
          <div className="users-modal-table-body">
            {
              currentDebtors.map((item) => {
                const isSelected = selectedPlaces.find((place) => place === item.place_id)
                return (
                  <div className="users-modal-table-body-item" key={item.key}>
                    <span className="users-modal-table-body-item-place">{item.place_name}</span>
                    <span className="users-modal-table-body-item-name">{item.owner_name || '---'}</span>
                    <CustomCheckbox
                      className={"users-modal-checkbox"}
                      onChange={() => handleSelectPlace({ value: item.place_id })}
                      value={isSelected ? [isSelected] : undefined}
                      options={[{ label: '', value: item.place_id }]}
                    />
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    </CustomModal>
  )
}

UsersModal.propTypes = {
  debtors: PropTypes.array.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  handleModalClose: PropTypes.func.isRequired
}

export default UsersModal
